/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { ServiceEndpoint } from 'client-code/sls-service-endpoints';

import { IDefaultServices } from '../interfaces/IDefaultServices';
import { Log } from '../logging/Log';
import { MsoDefaultBrandingUiBundleService } from './MsoDefaultBrandingUiBundleService';
import { SlsServiceGlobalEndpointsService } from './SlsServiceGlobalEndpointsService';

export class DefaultServices implements IDefaultServices {
    private TAG: string = 'DefaultServices';

    private slsBaseUrl: string;

    public constructor(url: string) {
        this.slsBaseUrl = url;
    }

    public getBrandingUiInfoForKey = (key: string) => {
        return new MsoDefaultBrandingUiBundleService().getBrandingUiInfoForKey(key);
    };

    public async fetchGlobalEndPoints(): Promise<ServiceEndpoint[]> {
        try {
            return await new SlsServiceGlobalEndpointsService(
                this.slsBaseUrl,
            ).fetchSlsGlobalEndpoints();
        } catch (error) {
            Log.e(this.TAG, 'fetchGlobalEndPoints()', error);
            throw error;
        }
    }

    public async fetchMsoDefaultBrandingUiInfo(): Promise<void> {
        try {
            return await new MsoDefaultBrandingUiBundleService().fetchMsoDefaultBrandingUiInfo();
        } catch (error) {
            Log.e(this.TAG, 'fetchMsoDefaultBrandingUiInfo', error);
            throw error;
        }
    }
}
